import { observable, action, configure, runInAction, flow } from "mobx";
import ProjectsApi from "@api/projects.api";

interface IProjectStores {
  projects: { title: string; type: string }[];
  project: any;
  isLoading: boolean;
  errors: any;
}

configure({ enforceActions: "observed" });

const filterObj = localStorage.getItem("filters");
const studentsFilterObj = localStorage.getItem("studentFilters");

class ProjectsStore implements IProjectStores {
  @observable filter: any =
    filterObj == null
      ? {
          gender: true,
          distance: true,
          germanLevel: true,
        }
      : JSON.parse(filterObj);
  
  @observable studentsFilter: any =
    studentsFilterObj == null
      ? {
          gender: true,
          knowledgeLevel: true
        }
      : JSON.parse(studentsFilterObj);

  @observable projects: any[] = [];

  @observable project: any = {};

  @observable currentProject: any = {};

  @observable isLoading = false;

  @observable isManualMode = false;

  @observable errors: any = null;

  @action.bound
  setFilterObj(obj: any) {
    this.filter = obj;
    localStorage.setItem("filters", JSON.stringify(obj));
  }

  @action.bound
  setStudentsFilter(obj: any) {
    this.studentsFilter = obj;
    localStorage.setItem("studentFilters", JSON.stringify(obj));
  }

  @action.bound
  handleChangeMode(e: any) {
    const { checked } = e.target;
    this.isManualMode = checked;
  }

  @action.bound
  async getCurrentProject(projectId, ignoreCache: false) {
    if (!this.projects.length || ignoreCache) {
      await this.getProjectsList();
    }

    const currentProject = this.projects.find(
      (project) => project._id === projectId
    );

    runInAction(() => {
      this.currentProject = currentProject;
    });
  }

  @action.bound
  handleChange({ target: { name, value } }: { target: HTMLInputElement }) {
    this.project[name] = value;
  }

  @action.bound
  setProject(institution: any) {
    this.project = institution;
  }

  addProject = flow(function* addProject(params: any) {
    this.isLoading = true;
    try {
      yield ProjectsApi.add(params);
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  cloneProject = flow(function* cloneProject(id: any) {
    this.isLoading = true;
    try {
      yield ProjectsApi.clone(id);
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  deleteProject = flow(function* deleteProject(id: string) {
    this.isLoading = true;
    try {
      yield ProjectsApi.delete(id);
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  getProjectsList = flow(function* getProjectsList() {
    this.isLoading = true;
    try {
      const list = yield ProjectsApi.fetch();

      this.projects = list;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  fetchDistribution = flow(function* fetchDistribution(
    _id: string,
    type: string
  ) {
    try {
      const { results, errors } = yield ProjectsApi.getDistribution(
        _id,
        type,
        type === 'Nursery' ? this.filter : this.studentsFilter
      );

      return { results, errors };
    } catch (error) {
      console.error(error);
    }
  });

  editProject = flow(function* editProject(params: any, id: string) {
    this.isLoading = true;
    try {
      yield ProjectsApi.edit({ ...params, _id: id });

      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  @action.bound
  getProject(id: string) {
    return this.data.find((e) => e._id === id);
  }
}

export default new ProjectsStore();
